import React from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import SuccessIcon from "../../assets/icons/SuccessToastIcon.svg";
import ErrorIcon from "../../assets/icons/ErrorToastIcon.svg";
import InfoIcon from "../../assets/icons/InfoToastIcon.svg";
import WarningIcon from "../../assets/icons/WarningToastIcon.svg";

import styles from "./successModal.module.css"; // assuming same folder, adjust path as needed

const toastConfig = {
  success: {
    icon: SuccessIcon,
    className: `${styles.toastSuccess}`,
  },
  error: {
    icon: ErrorIcon,
    className: `${styles.toastError}`,
  },
  info: {
    icon: InfoIcon,
    className: `${styles.toastInfo}`,
  },
  warning: {
    icon: WarningIcon,
    className: `${styles.toastWarning}`,
  },
};

const showToast = (type = "success", message, autoClose = 3000) => {
  const config = toastConfig[type] || toastConfig.success;

  toast(
    <div className={styles.toastContainer}>
      <img src={config.icon} alt={type} className={styles.toastIcon} />
      {message}
    </div>,
    {
      position: "top-center",
      autoClose,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      toastId: `toast-${Date.now()}`,
      icon: false,
      className: `${styles.toastBase} ${config.className}`,
    }
  );
};

export { showToast };
